module.exports = __webpack_public_path__ + "img/sword-water-03.f136b125.png";